import { render, staticRenderFns } from "./ElementAdDfp.vue?vue&type=template&id=acc37208"
import script from "./ElementAdDfp.vue?vue&type=script&lang=js"
export * from "./ElementAdDfp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports